<!-- Screen housing -->
<div
  #screen
  class="relative flex size-full items-center justify-between rounded-l-3xl border pt-[4%] pb-[6%] pl-[3%] shadow"
  [style.border-left-width.px]="borderLeftPixels()"
  [style.border-top-width.px]="borderTopPixels()"
  style="background-color: hsl(212, 6%, 48%); border-color: hsl(207, 5%, 65%)"
>
  <!-- Screen content -->
  <div class="h-full w-[70%]">
    <ng-content></ng-content>
  </div>
  <!-- Button(s) on the right -->
  <div class="m-[2%] mr-[0] flex h-full w-[30%] flex-col justify-between">
    <wk8-button
      color="orange"
      [icon]="swapButtonIcon()"
      [disabled]="swapButton() === 'disabled'"
      class="h-[48%]"
      (clicked)="swapButton() === 'disabled' ? undefined : swapped.emit()"
      [style]="{
        opacity: swapButton() === 'hidden' ? 0 : undefined,
      }"
    />
    <wk8-button
      color="green"
      icon="right-arrow"
      [disabled]="submitButton() === 'disabled'"
      class="h-[48%]"
      (clicked)="submitButton() === 'disabled' ? undefined : submitted.emit()"
      [style]="{
        opacity: submitButton() === 'hidden' ? 0 : undefined,
      }"
    />
  </div>
  <!-- Progress lights -->
  <div class="absolute top-0 left-[10%] h-1/5 w-2/5 -translate-y-full">
    <wk8-progress-lights [numSteps]="numSteps()" [numCompleted]="numCompleted()"></wk8-progress-lights>
  </div>
</div>
